module.exports = __webpack_public_path__ + "static/media/logo-new.f4a03e6a.png";